import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, PercentPipe, DecimalPipe } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormlyModule, FormlyField } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyMatDatepickerModule } from '@ngx-formly/material/datepicker';
import { NgApexchartsModule } from "ng-apexcharts";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalculatorComponent } from './components/calculator/calculator.component';
import { RepeatTypeComponent } from './shared/repeat-section.type';
import { AutocompleteTypeComponent } from './shared/autocomplete-type.component';
import { MatTableResponsiveModule } from './shared/mat-table-responsive/mat-table-responsive.module';

import { FlexLayoutModule } from '@angular/flex-layout';
import { ProgressSpinnerComponent } from './components/progress-spinner/progress-spinner.component';


@NgModule({
  declarations: [
    AppComponent,
    RepeatTypeComponent,
    AutocompleteTypeComponent,
    CalculatorComponent,
    ProgressSpinnerComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatListModule,
    MatDividerModule,
    MatSelectModule,
    MatStepperModule,
    MatInputModule,
    MatTableModule,
    MatRadioModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    MatTableResponsiveModule,
    NgApexchartsModule,
    FormlyMatDatepickerModule,
    FormlyMaterialModule,
    FlexLayoutModule,
    FormlyModule.forRoot({
      types: [
        { name: 'autocomplete', component: AutocompleteTypeComponent, wrappers: ['form-field'] },
        { name: 'repeat', component: RepeatTypeComponent },
      ],
      validationMessages: [
        { name: 'required', message: 'This field is required' },
      ],
    }),
  ],
  providers: [CurrencyPipe, PercentPipe, DecimalPipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
